// cribbed from calling-ui-library/hooks/useWorkerBroadcastEventHandler.ts
import { addBroadcastMessageHandler, removeBroadcastMessageHandler } from 'worker-connection-library/calling-cross-tab-utils/broadcastMessageHandler';
import { useEffect, useRef } from 'react';
import { OPEN_REMOTE_MESSAGE } from 'calling-lifecycle-messages/deviceEventConstants';
export function useOpenRemoteEventHandler({
  onDefaultEvent,
  onOpenRemoteMessage
}) {
  const defaultHandlers = {};
  const handlers = useRef(defaultHandlers);
  handlers.current[OPEN_REMOTE_MESSAGE] = onOpenRemoteMessage;
  const onDefaultEventRef = useRef(onDefaultEvent);
  onDefaultEventRef.current = onDefaultEvent;
  useEffect(() => {
    const handleOnReceiveMessageFromHost = message => {
      const {
        type
      } = message;
      const eventHandler = handlers.current[type];
      if (typeof eventHandler === 'function') {
        eventHandler(message);
      }
      if (onDefaultEventRef && onDefaultEventRef.current) onDefaultEventRef.current(message);
    };
    addBroadcastMessageHandler(handleOnReceiveMessageFromHost);
    return () => {
      removeBroadcastMessageHandler(handleOnReceiveMessageFromHost);
    };
  }, []);
}